import { ActionReducerMap, MetaReducer } from '@ngrx/store';
import * as AuthApiActions from '../auth/actions/auth-api.actions';

export interface State { }

export const reducers: ActionReducerMap<State> = { };

export const metaReducers: MetaReducer<State>[] = [clearState];

export function clearState(reducer) {
  return function (state, action) {

    if (action.type === AuthApiActions.logoutSuccess.type || action.type === AuthApiActions.logoutFailure.type) {
      state['unit'] = undefined;
      state['serviceBook'] = undefined;
      state['reportState'] = undefined;
      state['settingsState'] = undefined;
    }

    return reducer(state, action);
  };
}
